import {ReactComponent as ArrowRightIcon} from "../../../../core/ui/icon/ArrowRight.svg";

import "./_wallet-account-list-item.scss";

import {ListItem} from "@hipo/react-ui-toolkit";
import algosdk from "algosdk";
import classNames from "classnames";

import useAsyncProcess from "../../../../core/network/async-process/useAsyncProcess";
import {fetchAccountAssetDetails} from "../../../util/walletUtils";
import {AppStateAccountData} from "../../accountTypes";
import AccountBalance from "../../balance/AccountBalance";
import AccountAddress from "../../address/AccountAddress";
import {AssetListItemData} from "../../../../asset/util/assetModels";
import Typography from "../../../../component/typography/Typography";
import IconButton from "../../../../component/button/icon/IconButton";

export interface WalletAccountListItemProps {
  account: AppStateAccountData;
  onSelect: (
    account: {detail: AppStateAccountData; assets: AssetListItemData[]},
    setInWalletAccountsAsWell?: boolean
  ) => void;
}

function WalletAccountListItem({account, onSelect}: WalletAccountListItemProps) {
  const {state: accountAssetDetailsAsyncProcessState, runAsyncProcess} =
    useAsyncProcess();
  const balance =
    typeof account?.amount === "bigint"
      ? algosdk.microalgosToAlgos(Number(account.amount))
      : 0;

  return (
    <ListItem
      customClassName={"wallet-account-list-item"}
      clickableListItemProps={
        accountAssetDetailsAsyncProcessState.isRequestPending
          ? undefined
          : {
              onClick: selectAccount
            }
      }>
      <div className={"wallet-account-list-item__content-wrapper"}>
        <AccountAddress
          address={account.address}
          nfdomain={account.nfdomain}
          description={"Address"}
          customClassName={"wallet-account-list-item__address"}
        />

        <div
          className={classNames(
            "is-vertically-centered",
            "is-aligned-right",
            "wallet-account-list-item__balance-info"
          )}>
          <div>
            <AccountBalance amount={balance} typographyProps={{variant: "body"}} />

            <Typography as={"p"} variant={"caption"} textColor={"text-gray-lighter"}>
              {"ALGO Balance"}
            </Typography>
          </div>

          <IconButton>
            <ArrowRightIcon />
          </IconButton>
        </div>
      </div>
    </ListItem>
  );

  async function selectAccount() {
    const assets = await runAsyncProcess(fetchAccountAssetDetails(account));

    onSelect({detail: account, assets});
  }
}

export default WalletAccountListItem;
